import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { ellipsisStyle, wideWidth } from '../../styles/CommonStyles';

export const wideField = style({
  ...wideWidth,
  // use nested styles to make the inputs match the parent's width, because the widget does not do that by default
  '$nest': {
    '& input': {
      ...wideWidth,
    },
  },
});

export const generatedUrlDivStyle = style(
  ellipsisStyle,
  {
    paddingBottom: TabStyles.Spacing.MediumSpace
  });

export const tableLayout = style({
  tableLayout: 'fixed',
});

export const tableCell = style({
  paddingRight: 2 * TabStyles.Spacing.LargeSpace,
  paddingTop: TabStyles.Spacing.MediumSpace,
  whiteSpace: 'nowrap',
});
